import React from 'react';
import { useStyles } from './ZoneListItem.styles';
import { imageZone, zoneDragItemType } from '../ZonesList.types';
import { useDrop, DropTargetMonitor } from 'react-dnd';

interface ZoneDropAreaProps {
  children: React.ReactElement;
  zone: imageZone | null;
  onDropZone: (draggedZone: imageZone, targetZone: imageZone | null) => void;
}

export const ZoneDropArea: React.FC<ZoneDropAreaProps> = ({ children, zone, onDropZone }) => {
  const classes = useStyles();

  const [{ isOver }, dropRef] = useDrop(
    () => ({
      accept: zoneDragItemType.ZONE,
      drop: (draggedItem: imageZone) => {
        onDropZone(draggedItem, zone);
      },
      collect: (monitor: DropTargetMonitor<imageZone, unknown>) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [zone, onDropZone],
  );

  return (
    <div ref={dropRef} className={isOver ? classes.activeDropArea : undefined}>
      {children}
    </div>
  );
};
